import { createContext } from 'react';

export const UnassignDeviceContext = createContext();
export const UnassignDeviceDispatchContext = createContext();
